import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../../ui_game/UIGameManager'
import {UIGameBaseTradeOfferActionsView} from './UIGameBaseTradeOfferActionsView'
import {TradeViewSpriteButton} from '../TradeViewSpriteButton'
import {FloatingText} from '../../game_ui_view_objects/FloatingText'
import {Sprites} from '../../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TradeActions, TradeResponse, TradeValidator} from '@colonist/game-mechanic-validators'
import {TradeResponseStatus} from '@colonist/game-states'

export class UIGameTradeOfferActionsViewNotMyTurn extends UIGameBaseTradeOfferActionsView {
    private counterOfferButton?: TradeViewSpriteButton | undefined

    rejectTradeButton?: TradeViewSpriteButton | undefined
    private acceptTradeButton?: TradeViewSpriteButton | undefined

    constructor(uiGameManager: UIGameManager, container: PIXI.Container, x: number, y: number, actionSize: number, tradeController: TradeValidator) {
        super(uiGameManager, container, x, y, actionSize, tradeController)

        this.buildActionButtons()

        this.onPlayerActionState = () => {
            this.rebuildActionButtons()
        }
    }

    onPlayerResponseStatus() {
        for(const playerResponse of this.stateController.getPlayerResponseStates()) {
            if(playerResponse.player != this.uiGameManager.gameController.myColor) continue
            this.highlightResponseButton(playerResponse.responseStatus)
        }
    }

    private buildActionButtons() {
        this.counterOfferButton = this.createCounterOfferButton()
        this.rejectTradeButton = this.createRejectOfferButton(() => {
            this.highlightResponseButton(TradeResponseStatus.Rejected)
        })

        this.acceptTradeButton = this.createAcceptOfferButton()

        if(this.amIEmbargoed()) {
            this.counterOfferButton?.addEmbargoSlash()
            this.acceptTradeButton?.addEmbargoSlash()
            this.rejectTradeButton?.addEmbargoSlash()
        }

        const myResponse = this.stateController.getPlayerResponseState(this.uiGameManager.gameController.myColor)
        if(myResponse) this.highlightResponseButton(myResponse.responseStatus)

        const timeToAutoReject = this.stateController.getTradeAutoRejectionTime(this.uiGameManager.gameController.gameSettings.gameSpeed, this.uiGameManager.gameController.myColor)
        if(!this.amITradeCreator()) this.triggerAutoRejectionCountdown(timeToAutoReject)
    }

    private rebuildActionButtons() {
        this.counterOfferButton?.destroy()
        this.rejectTradeButton?.destroy()
        this.acceptTradeButton?.destroy()

        this.buttonX = 0
        this.buildActionButtons()
    }

    private createAcceptOfferButton(): TradeViewSpriteButton | undefined {
        const acceptTradeAction = this.stateController.getAcceptTradeActionStatus(this.uiGameManager.gameController.myColor)
        if(!acceptTradeAction.displayActionButton) return undefined

        const isAcceptButtonEnabled = acceptTradeAction.canTakeAction
        const acceptTradeButton = this.createButton(isAcceptButtonEnabled, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_check))
        const acceptButtonAction = () => this.acceptButtonAction(acceptTradeButton)
        acceptTradeButton.updateAction(acceptButtonAction)
        acceptTradeButton.setTip({key: 'strings:colonistCommon.utils.emptyString'}, [{key: 'strings:game.tooltips.acceptTrade'}])
        return acceptTradeButton
    }

    private acceptButtonAction(acceptTradeButton: TradeViewSpriteButton) {
        if(this.stateController.state.forcedResponse == TradeResponseStatus.Rejected) {
            return this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.BeginnerModeForceOpenGuideBubble)
        }

        const acceptTradeAction = this.stateController.getAcceptTradeActionStatus(this.uiGameManager.gameController.myColor)

        if(!acceptTradeAction.canTakeAction) {
            if(acceptTradeAction.errorMessageIfCantTakeAction == undefined) return
            new FloatingText(acceptTradeAction.errorMessageIfCantTakeAction, acceptTradeButton)
            return
        }
        const acceptTrade: TradeResponse = {
            id: this.stateController.state.id,
            response: TradeActions.Accept,
        }
        this.uiGameManager.socketGameSend.updateTradeResponse(acceptTrade)
        this.highlightResponseButton(TradeResponseStatus.Accepted)
        this.rejectTradeButton?.clearCooldownAnimation()
    }

    private highlightResponseButton(responseStatus: TradeResponseStatus) {
        this.removeAllButtonHighlights()

        switch(responseStatus) {
            case TradeResponseStatus.Accepted: this.acceptTradeButton?.highlight(); break
            case TradeResponseStatus.Rejected: this.rejectTradeButton?.highlight(); break
            case TradeResponseStatus.PendingResponse: break
            case TradeResponseStatus.Embargoed: break
        }
    }

    private removeAllButtonHighlights() {
        this.acceptTradeButton?.removeHighlight()
        this.counterOfferButton?.removeHighlight()
        this.rejectTradeButton?.removeHighlight()
    }

    private amIEmbargoed(): boolean {
        const myResponseStatus = this.stateController.getPlayerResponseState(this.uiGameManager.gameController.myColor)
        return myResponseStatus?.responseStatus == TradeResponseStatus.Embargoed
    }
}
